// src/components/Webapps2Folder/CardStyles.js
import styled from "styled-components";

export const CardInfo = styled.div`
  color: #44fd47;
  font-family: "Orbitron", sans-serif;
  font-size: 1rem;
  text-align: center;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  padding: 0.5rem 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Description = styled.p`
  margin: 0;
  color: #ffffff;
  font-family: "Orbitron", sans-serif;
  font-size: 0.7rem;
  text-align: start;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  padding: 0.5rem;
  background: rgba(0, 0, 0, 0.5);
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.8);
  white-space: normal;
  line-height: 1.2;
  @media screen and (max-width: 768px) {
    font-size: 0.6rem;
    padding: 0.4rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.5rem 0;
  gap: 0.5rem;
  height: 3rem;
`;

export const StyledButton = styled.a.attrs(({ as }) => ({
  as: as || "a",
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 44px;
  white-space: nowrap;
  padding: 6px 14px;
  font-family: "Orbitron", sans-serif;
  color: #44ff46;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  &:hover {
    background: #44ff46;
    color: #010606;
  }
`;

export const BannerContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;
`;

export const Banner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${(props) => props.backgroundColor || "#ff4b4b"};
  color: ${(props) =>
    props.textColor ||
    (props.backgroundColor === "#ffe501" ? "#000000" : "#ffffff")};
  padding: 0.5rem 1rem;
  font-weight: bold;
  font-family: "Orbitron", sans-serif;
  font-size: 0.9rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 10;
  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
`;